var BOX_TYPES = {
  CATEGORY: 'category-box',
  GROUP: 'group-box'
};
var BOX_TYPES_ARRAY = [BOX_TYPES.CATEGORY, BOX_TYPES.GROUP];

export { BOX_TYPES, BOX_TYPES_ARRAY };
//# sourceMappingURL=constants.js.map
